const networksFilters = () => {
  const listsPosts = document.querySelectorAll('#main .col-full .list-social');
  const listsSlickPosts = document.querySelectorAll('#main .col-full .slider-social');
  const filters = document.querySelectorAll('.rs a');

  const showOnly = (element) => {
    listsPosts.forEach(list => list.classList.remove('hide-facebook', 'hide-youtube', 'hide-instagram'));
    listsSlickPosts.forEach(list => list.classList.remove('hide-facebook', 'hide-youtube', 'hide-instagram'));
    console.log(element)
    switch (element) {
      case 'facebook-filter':
        listsPosts.forEach(list => list.classList.add('hide-instagram', 'hide-youtube'));
        listsSlickPosts.forEach(list => list.classList.add('hide-instagram', 'hide-youtube'));
        break;
      case 'instagram-filter':
        listsPosts.forEach(list => list.classList.add('hide-facebook', 'hide-youtube'));
        listsSlickPosts.forEach(list => list.classList.add('hide-facebook', 'hide-youtube'));
        break;
      case 'youtube-filter':
        listsPosts.forEach(list => list.classList.add('hide-facebook', 'hide-instagram'));
        listsSlickPosts.forEach(list => list.classList.add('hide-facebook', 'hide-instagram'));
        break;
      default:
        // Unknown filter
        return;
    }
  };

  const handleClick = (e) => {
    return true;
    e.preventDefault();
    const id = e.currentTarget.getAttribute('id');
    showOnly(id);
  };

  const init = () => {
    if (!listsPosts || !listsSlickPosts || !filters) return;
    filters.forEach(filter => filter.addEventListener('click', handleClick));
  };

  init();
};

export default networksFilters;
